// extracted by mini-css-extract-plugin
module.exports = {"item":"block_item__FZ3ZZ","heading":"block_heading__nK5Fk","isOpen":"block_isOpen__nwR2R","content":"block_content__xwMp0","innerContent":"block_innerContent__h_A5Q"};